import Marionette from "../../../shared/marionette-mustache";
import { CaseRelationModel } from "../../../desktop/models/case-relation";
import { backboneViewProperties } from "../../../decorators/backbone-properties";
import { ResultModel } from "../../../search/models/result";

const template = require<string>("../../../desktop/views/partials/category-case-relation.html");

@backboneViewProperties({
    tagName: "div",
    template
})
export class CategoryCaseRelationView extends Marionette.ItemView<ResultModel> {
    constructor(options?: Backbone.ViewOptions<ResultModel>) {
        super(options);
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/desktop/views/partials/category-case-relation.ts